import { Controller } from "@hotwired/stimulus"

// Состав обработки: несколько строк «приход + количество палет».
// Показывает живую сумму исходных палет.
//
// Приходы в составе могут быть с РАЗНЫХ складов-источников — это штатный
// сценарий («сколько-то одного типа, сколько-то другого»), поэтому опции
// в селектах не блокируются. Единственное ограничение — рабочий склад, и оно
// обеспечивается на сервере: контроллер отдаёт в форму только приходы текущего
// склада (ProcessingsController#load_form_data).
export default class extends Controller {
  static targets = ["row", "palletsInput", "total"]

  connect() {
    this.renderTotal()
    // cocoon вставляет/удаляет строки вне жизненного цикла Stimulus —
    // пересчитываем после каждой операции.
    this.boundRefresh = () => this.renderTotal()
    this.element.addEventListener("cocoon:after-insert", this.boundRefresh)
    this.element.addEventListener("cocoon:after-remove", this.boundRefresh)
  }

  disconnect() {
    this.element.removeEventListener("cocoon:after-insert", this.boundRefresh)
    this.element.removeEventListener("cocoon:after-remove", this.boundRefresh)
  }

  refresh() {
    this.renderTotal()
  }

  // Вызывается кнопкой «Убрать»: DOM меняется после обработчика cocoon.
  scheduleRefresh() {
    setTimeout(() => this.renderTotal(), 0)
  }

  // Удалённые существующие строки cocoon не выкидывает из DOM, а прячет
  // (display: none) и помечает _destroy=1 — такие строки в сумму не идут.
  rowVisible(element) {
    const row = element.closest(".nested-fields")
    return row !== null && row.style.display !== "none"
  }

  renderTotal() {
    if (!this.hasTotalTarget) return

    const sum = this.palletsInputTargets
      .filter((input) => this.rowVisible(input))
      .reduce((acc, input) => acc + (parseInt(input.value, 10) || 0), 0)

    this.totalTarget.textContent = String(sum)
  }
}
